import { useEffect } from 'react';
import { useQuill } from 'react-quilljs';
import { PageIcon } from '@/types';

const ShowTextNote = ({
  userNote,
  isUpdate,
}: {
  userNote: PageIcon;
  isUpdate: boolean;
}) => {
  const theme = 'snow';
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ['link', 'image', 'video', 'formula'],
      ['clean'],
    ],
  };

  const placeholder = '...';

  const formats = ['bold', 'italic', 'underline', 'strike'];

  const { quill, quillRef } = useQuill({
    theme,
    modules,
    formats,
    placeholder,
  });

  useEffect(() => {
    quill?.clipboard.dangerouslyPasteHTML(userNote?.content || '');
  }, [userNote, quill]);
  return (
    <>
      {isUpdate ? (
        <div
          style={{
            border: '1px solid #ccc',
            padding: '10px',
            height: '450px',
            width: '900px',
            overflowY: 'auto',
          }}
        >
          <div ref={quillRef} />
        </div>
      ) : (
        <div
          style={{
            border: '1px solid #ccc',
            padding: '10px',
            height: '450px',
            width: '900px',
            overflowY: 'auto',
          }}
          dangerouslySetInnerHTML={{ __html: userNote.content || '' }}
        />
      )}
    </>
  );
};

export default ShowTextNote;
